import { Assets, Box, Button, Flex, Text } from '@foradevelopment/fora-ui';
import { FAGroupViewModel } from '@fora-monorepo/employer-my-pages-common/types';

import { ExtendedMarkupType } from './MarkupEditList';
import { useTypedTranslation } from '../../i18n/i18n';

type MarkupInfoProps = {
  onClick: () => void;
  markup: ExtendedMarkupType;
  onDeleteClick: () => void;
  onRevertClick: () => void;
  // TODO: Remove when the start date of the first employment period becomes editable.
  editable?: boolean;
  markupOptions: FAGroupViewModel[];
  ends: string | null;
};

export const MarkupInfo = ({
  onClick,
  markup,
  onDeleteClick,
  onRevertClick,
  editable,
  markupOptions,
  ends,
}: MarkupInfoProps) => {
  const { t } = useTypedTranslation();

  const validTo = markupOptions.find(m => m.faGroupId === markup.faGroupId)?.validTo;
  const newMarkupValidTo = markupOptions.find(m => m.faGroupId === markup.newMarkup?.faGroupId)?.validTo;

  return (
    <Box>
      <Text
        size="small"
        color="black70"
        marginBottom={6}
        textDecoration={markup.deletedMarkup || markup.newMarkup ? 'line-through' : 'none'}
      >
        {ends
          ? t('common.datetodate', {
              date: markup.newMarkup ? markup.newMarkup.startDate : markup.startDate,
              endDate: ends,
            })
          : t('common.validFromDate', { date: markup.startDate })}
      </Text>
      <Text size="medium" textDecoration={markup.deletedMarkup || markup.newMarkup ? 'line-through' : 'none'}>
        {markup.fokText}
      </Text>

      {validTo && (
        <Flex marginBottom={10}>
          <Assets.TriangleExclamationIcon color={'burgundy'} width={22} marginRight={7} />
          <Text
            textDecoration={markup.deletedMarkup || markup.newMarkup ? 'line-through' : 'none'}
            color="burgundy"
          >{`${t('warningMessages.fokWillExpire', { expirationDate: validTo })}`}</Text>
        </Flex>
      )}
      {markup.newMarkup && (
        <Box style={{ borderLeft: '4px solid black' }} paddingLeft={20}>
          <Text color="black70" size="small">
            {t('common.validFromDate', { date: markup.newMarkup.startDate })}
          </Text>
          <Text>{markup.newMarkup?.fokText}</Text>
          {newMarkupValidTo && (
            <Flex marginBottom={10}>
              <Assets.TriangleExclamationIcon color={'burgundy'} width={22} marginRight={7} />
              <Text color="burgundy">{`${t('warningMessages.fokWillExpire', { expirationDate: newMarkupValidTo })}`}</Text>
            </Flex>
          )}
        </Box>
      )}

      <Flex columnGap={20} marginTop={10}>
        <Box>
          <Button styleAs="link" onClick={onClick}>
            {t('common.edit')}
            <Assets.EditIcon marginLeft={7} />
          </Button>
        </Box>
        <Box>
          {markup.deletedMarkup || markup.newMarkup ? (
            <Button styleAs="link" color="burgundy" onClick={onRevertClick}>
              {t('common.undo')} <Assets.ResetIcon color="burgundy" width={14} marginLeft={7} />
            </Button>
          ) : editable ? (
            <Button styleAs="link" onClick={onDeleteClick}>
              {t('common.remove')} <Assets.TrashIcon color="foraBlue" marginLeft={7} />
            </Button>
          ) : null}
        </Box>
      </Flex>
    </Box>
  );
};
